module.exports = __webpack_public_path__ + "img/Vatican City.8e67e877.svg";